import { render, staticRenderFns } from "./tooltips.vue?vue&type=template&id=2c7614e0&scoped=true&"
import script from "./tooltips.vue?vue&type=script&lang=js&"
export * from "./tooltips.vue?vue&type=script&lang=js&"
import style0 from "./tooltips.vue?vue&type=style&index=0&id=2c7614e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7614e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7614e0')) {
      api.createRecord('2c7614e0', component.options)
    } else {
      api.reload('2c7614e0', component.options)
    }
    module.hot.accept("./tooltips.vue?vue&type=template&id=2c7614e0&scoped=true&", function () {
      api.rerender('2c7614e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tooltips.vue"
export default component.exports